import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { ProjectorContainer, ProjectorContainerWidgetsResponse } from './projector-containers.models'
import { ProjectorsEntity } from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.models'

@Injectable({
  providedIn: 'root',
})
export class ProjectorContainersApiService extends GbApiService {
  getProjectorContainers(urlName: string): Observable<ProjectorContainer[]> {
    return this.get<ProjectorContainer[]>(`auctions/${urlName}/projector-containers/`)
  }

  createProjectorContainer(
    urlName: string,
    projectorContainer: Partial<ProjectorContainer>,
  ): Observable<ProjectorContainer> {
    const url = `auctions/${urlName}/projector-containers/`
    return this.post<ProjectorContainer>(url, projectorContainer)
  }

  updateProjectorContainer(projectorContainer: Partial<ProjectorContainer>): Observable<ProjectorContainer> {
    const url = `auctions/${projectorContainer.auction}/projector-containers/${projectorContainer.uuid}/`
    return this.patch<ProjectorContainer>(url, projectorContainer)
  }

  deleteProjectorContainer(urlName: string, uuid: string): Observable<void> {
    const url = `auctions/${urlName}/projector-containers/${uuid}/`
    return this.delete<void>(url)
  }

  getProjectorContainerWidgets(urlName: string, containerUuid: string): Observable<ProjectorContainerWidgetsResponse> {
    const url = `auctions/${urlName}/projector-containers/${containerUuid}/widgets/`
    return this.get<ProjectorContainerWidgetsResponse>(url)
  }

  duplicateSlide(
    urlName: string,
    containerUuid: string,
    projectorUuid: string,
    name?: string,
  ): Observable<ProjectorsEntity> {
    const url = `auctions/${urlName}/projector-containers/${containerUuid}/duplicate-slide/`
    return this.post<ProjectorsEntity>(url, { projector: projectorUuid, name })
  }
}
